import { AgGridReact } from 'ag-grid-react';
import { useRef } from 'react';
import Header from '../../common/Header/Header';
import { Page, TableWrapper } from '../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Table from '../../components/Table/Table';
import { useProductGroups } from '../../services/productGroup/productGroup.service';
import { useFetchErrorToast } from '../../utils/useFetchErrorToasts/useFetchErrorToast';

const ProductGroups = () => {
    const gridRef = useRef<AgGridReact>(null);
    const { data, isError } = useProductGroups();
    useFetchErrorToast([{ isError, label: 'Error fetching Product Groups', id: 'productGroupFetchError' }]);
    return (
        <>
            <Header breadcrumb={{ to: '/tables', label: 'All tables' }} title='Product Group' titleTestId={'ProductGroupsPageTitle'} />
            <Page>
                <TableWrapper>
                    <Table
                        rowData={data?.data}
                        ref={gridRef}
                        height={'100%'}
                        returnedRecords={data?.data?.length}
                        columnDefs={[
                            { minWidth: 100, field: 'productGroupNo', headerName: 'Product Group No.' },
                            { minWidth: 300, field: 'description', headerName: 'Description' }
                        ]}
                    />
                </TableWrapper>
            </Page>
        </>
    );
};

export default ProductGroups;